import { TextHOneIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading1 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHOneIcon size={Sizes[size]} {...rest} color={fill} />;
};

Heading1.displayName = 'Heading1';
